import { INSPECTIONS_FILTER_RESET_DATE } from "redux/types";
import inspectionsLoad from "./inspectionsLoad";

export default function inspectionsFilterResetDate() {
    return async (dispatch) => {
        await dispatch({ type: INSPECTIONS_FILTER_RESET_DATE });
        dispatch(inspectionsLoad());
    };
}